import { get, put, post } from './utils';

export async function getAllRegionsApi(data) {
  return get(`/api/public/um/region`);
}

export async function getAllCountiesApi(data) {
  return get(`/api/public/um/county/country`, data);
}

export async function searchCountiesApi(data) {
  return post(`/api/public/um/county/search`, data);
}
export async function getCountyByIdApi(id) {
  return get(`/api/public/um/county/` + id);
}
export async function getRegionByIdApi(id) {
  return get(`/api/public/um/region/` + id);
}

export async function searchConstituencyApi(data) {
  return post(`/api/um/constituency/search`, data);
}

export async function addConstituencyApi(data) {
  return post(`/api/um/constituency`, data);
}

export async function getConstituencyByIdApi(id) {
  return get(`/api/um/constituency/` + id);
}

export async function getWardByIdApi(id) {
  return get(`/api/um/ward/` + id);
}

export async function addWard(data) {
  return post(`/api/um/ward/save`, data);
}
export async function updateWard(data) {
  return put(`/api/um/ward/update`, data);
}

export async function addConstituency(data) {
  return post(`/api/um/constituency/save`, data);
}
export async function updateConstituency(data) {
  return put(`/api/um/constituency/update`, data);
}

export async function addCounty(data) {
  return post(`/api/um/county/save`, data);
}
export async function updateCounty(data) {
  return put(`/api/um/county/update`, data);
}

export async function searchWardsApi(data) {
  return post(`/api/um/ward/search`, data);
}

export async function searchRegionsApi(data) {
  return post(`/api/public/um/region/search`, data);
}

export async function getAllCountiesByRegionApi(data) {
  return get(`/api/public/um/county`, data);
}

export async function getConstituencyApi(data) {
  return get(`/api/public/um/constituency`, data);
}

export async function getAllWardsApi(data) {
  return get(`/api/public/um/ward`, data);
}
export async function getAllRelationshipsApi(data) {
  return get(`/api/public/um/setup/relationship`, data);
}

export async function getAgeLimitsApi() {
  return get(`/api/public/um/setup/age-limits`);
}

export async function getMemberStatusCountsApi(data) {
  return post(`/api/report/member/counts`, data);
}

export async function getAllAllMembersReportsApi(data) {
  return post(`/api/report/member/search`, data);
}

export async function getDependentsStatusCountsApi(data) {
  return post(`/api/report/member/dependentsApplications`, data);
}

export async function getGroupStatusCountsApi(data) {
  return post(`/api/report/group/counts`, data);
}

export async function getPaymentsStatusCountsApi(data) {
  return post(`/api/report/transaction/counts`, data);
}

export async function getClaimStatusCountsApi(data) {
  return post(`/api/report/claim/counts`, data);
}

export async function getApplicationStatusCountsApi(data) {
  return post(`/api/report/application/status/counts`, data);
}

export async function getGroupTransferStatusCountsApi(data) {
  return post(`/api/report/group/transfer/counts`, data);
}

export async function getTransferStatusCountsApi(data) {
  return post(`/api/report/transfer/status/counts`, data);
}

export async function getInvoicesCountsApi(data) {
  return post(`/api/report/transaction/invoices/counts`, data);
}

export async function getCommunicationCountsApi(data) {
  return post(`/api/report/communication/counts`, data);
}
